import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import FileUpload from "./FileUpload";
import { ItemContext } from "../../Context/ItemContext";
import { useHistory, Link } from "react-router-dom"; // Add Link

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createItem, updateItem } from "../../actions/itemActions";
import { useSnackbar } from "../../utils/useSnackbar";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import AddIcon from "@material-ui/icons/Add";
import SearchIcon from "@material-ui/icons/Search";
import { StockContext } from "../../Context/StockContext";
import { createUnit, getAllUnits } from "../../actions/unitActions";
import { useEffectiveProfile } from "../../utils/useEffectiveProfile";
import { useCompany } from "../../Context/CompanyContext";
import { getTaxLabel } from "../../utils/currency";
import {
  createCategory,
  getAllCategories,
  deleteCategory,
} from "../../actions/categoryActions";
import {
  FormControl,
  InputLabel,
  MenuItem,
  ListSubheader,
  Select,
  Container,
  FormControlLabel,
  Switch,
  FormGroup,
  Radio,
  FormHelperText,
  CircularProgress,
  useMediaQuery,
  InputAdornment,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backgroundColor: "#1976D2",
    marginLeft: 0,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "white",
  },
  inputStyle: {
    width: "100%",
    fontFamily: "kruti-101",
  },
  formControl: {
    width: "100%",
  },
  container: {
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px",
  },
  radioLabel: {
    // margin: theme.spacing(1, 0),
    display: "block",
  },
  input: {
    display: "none",
  },
  disabledMenuItem: {
    color: theme.palette.text.disabled, // Greyed out style for inactive categories
  },
  quickCreateItem: {
    position: "sticky",
    bottom: 0,
    zIndex: 1,
    color: "#d96f17",
    fontWeight: 700,
    backgroundColor: "#fffaf5",
    borderTop: "1px solid #fed7aa",
    "&:hover": { backgroundColor: "#fff3e6" },
  },
  quickDialogContent: {
    display: "grid",
    gap: theme.spacing(2),
    minWidth: 280,
    paddingTop: theme.spacing(2),
  },
  menuPaper: {
    "&::-webkit-scrollbar": { width: 5 },
    "&::-webkit-scrollbar-track": { background: "transparent" },
    "&::-webkit-scrollbar-thumb": {
      background: "#94a3b8",
      borderRadius: 999,
    },
  },
  searchHeader: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    backgroundColor: "#fff",
    padding: theme.spacing(1, 1.25),
    borderBottom: "1px solid #eef1f5",
    boxShadow: "0 2px 4px rgba(15, 23, 42, 0.04)",
  },
  searchInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      backgroundColor: "#f8fafc",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ef7f1a",
    },
  },
  noResultsItem: {
    color: theme.palette.text.disabled,
    fontStyle: "italic",
    justifyContent: "center",
    opacity: 1,
  },
}));

const SearchListHeader = ({ classes, value, onChange, placeholder }) => (
  <ListSubheader className={classes.searchHeader}>
    <TextField
      autoFocus
      size="small"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyDown={(event) => event.stopPropagation()}
      onClick={(event) => event.stopPropagation()}
      variant="outlined"
      fullWidth
      className={classes.searchInput}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" style={{ color: "#94a3b8" }} />
          </InputAdornment>
        ),
      }}
    />
  </ListSubheader>
);

const DialogTitle = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = (props) => {
  const classes = useStyles();
  return <MuiDialogContent {...props} />;
};

const DialogActions = (props) => {
  const classes = useStyles();
  return <MuiDialogActions {...props} />;
};
// const units = [
//   {
//     _id: "661a1f3b4b3f5a001f3e1001",
//     name: "Kilogram",
//     abbreviation: "kg",
//     baseUnit: null,
//     conversionFactor: 1,
//     type: ["STOCK", "SALE", "PURCHASE", "ADJUSTMENT"],
//   },
//   {
//     _id: "661a1f3b4b3f5a001f3e1002",
//     name: "Gram",
//     abbreviation: "g",
//     baseUnit: "661a1f3b4b3f5a001f3e1001", // Reference to Kilogram
//     conversionFactor: 0.001,
//     type: ["STOCK", "SALE", "PURCHASE"],
//   },
//   {
//     _id: "661a1f3b4b3f5a001f3e1003",
//     name: "Liter",
//     abbreviation: "L",
//     baseUnit: null,
//     conversionFactor: 1,
//     type: ["STOCK", "SALE", "PURCHASE", "ADJUSTMENT"],
//   },
//   {
//     _id: "661a1f3b4b3f5a001f3e1004",
//     name: "Milliliter",
//     abbreviation: "mL",
//     baseUnit: "661a1f3b4b3f5a001f3e1003", // Reference to Liter
//     conversionFactor: 0.001,
//     type: ["STOCK", "SALE", "PURCHASE"],
//   },
// ];

const AddItem = ({ setOpen, open, initialItemName, onCreated }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const history = useHistory();

  const location = useLocation();
  const effectiveProfile = useEffectiveProfile();
  const taxLabel = getTaxLabel(effectiveProfile?.currency);
  // Special Feature toggle (see SuperAdmin > Global Settings) - when off,
  // Minimum Sale Quantity is never enforced anywhere (see CartContext.js's
  // getItemMinSaleQty), so there's nothing for this field to do - hide it
  // entirely instead of showing a control that silently has no effect.
  const { company } = useCompany();
  const minSaleQuantityFeatureOn = company?.minSaleQuantityEnabled === true;
  const units = useSelector((state) => state.units.units);
  // console.log(units);
  const [itemData, setItemData] = useState({
    itemName: "",
    category: {
      categoryName: "",
      categoryId: null,
    },
    units: {
      sale: {
        unit: null,
        price: "",
        minQty: "",
      },
      purchase: {
        unit: null,
        cost: "",
      },
      stock: {
        unit: null,
        quantity: 0,
      },
    },
    barcode: "",
    img: null,
    toggleStock: false,
    isStaffReq: false,
    stockQty: {
      initialQty: 0,
      currentQty: 0,
      minQty: 0,
      maxQty: 0,
    },
    vat: effectiveProfile?.commonVatRate || "",
  });
  // const [itemData, setItemData] = useState({
  //   itemName: "",
  //   category: {
  //     categoryName: "",
  //     categoryId: "",
  //   },
  //   unitPrice: "",
  //   costPrice: "",
  //   barcode: "",
  //   unit: "",
  //   itemId: [],
  //   img: null,
  //   toggleStock: false,
  //   isStaffReq: false,
  //   stockQty: {
  //     initialQty: 0,
  //     currentQty: 0,
  //     minQty: 0,
  //     maxQty: 0,
  //   },

  // });
  const { itemId, setItemId } = useContext(ItemContext);
  const dispatch = useDispatch();
  const item = useSelector((state) =>
    itemId ? state.items.items.find((i) => i._id === itemId) : null
  );
  // console.log("Edit item", item);
  const { categories } = useSelector((state) => state.categories);
  const selectedSaleUnit = units.find((unit) => unit._id === itemData?.units?.sale?.unit);
  const selectedStockUnit = units.find((unit) => unit._id === itemData?.units?.stock?.unit);

  const [isEditMode, setIsEditMode] = useState(false); // New state variable
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quickCreateType, setQuickCreateType] = useState(null);
  const [quickCategoryName, setQuickCategoryName] = useState("");
  const [categorySearch, setCategorySearch] = useState("");
  const [saleUnitSearch, setSaleUnitSearch] = useState("");
  const [purchaseUnitSearch, setPurchaseUnitSearch] = useState("");
  const [stockUnitSearch, setStockUnitSearch] = useState("");
  const [pendingCategoryName, setPendingCategoryName] = useState("");
  const [quickUnitName, setQuickUnitName] = useState("");
  const [quickUnitAbbreviation, setQuickUnitAbbreviation] = useState("");
  const [isQuickCreating, setIsQuickCreating] = useState(false);
  const keepItemDialogOpenRef = useRef(false);
  const { stock, trackStock, setTrackStock, getCurrentStockQty } = useContext(StockContext);
  // const [option, setOption] = useState("manualAdd"); // Default to fileUpload for new items
  const handleTrackStockChange = (event) => {
    setTrackStock(event.target.checked);
    setItemData({
      ...itemData,
      toggleStock: event.target.checked,
    });
  };

  const menuProps = {
    PaperProps: {
      classes: { root: classes.menuPaper },
      style: {
        maxHeight: 280, // Adjust this value as needed
        overflowY: "auto", // Enables vertical scrolling
        scrollbarWidth: "thin",
        scrollbarColor: "#64748b transparent",
      },
    },
  };

  const sortedCategories = [...categories].sort((first, second) =>
    (first.categoryName || "").localeCompare(second.categoryName || "", undefined, {
      sensitivity: "base",
    })
  );
  const startsWithQuery = (text, query) =>
    (text || "").toLowerCase().startsWith(query.trim().toLowerCase());

  const filteredCategories = sortedCategories.filter((category) =>
    startsWithQuery(category.categoryName, categorySearch)
  );

  const filterUnitsByQuery = (query) => {
    if (!query.trim()) return units;
    return units.filter(
      (unit) =>
        startsWithQuery(unit.name, query) ||
        startsWithQuery(unit.abbreviation, query)
    );
  };

  const filteredSaleUnits = useMemo(
    () => filterUnitsByQuery(saleUnitSearch),
    [units, saleUnitSearch]
  );
  const filteredPurchaseUnits = useMemo(
    () => filterUnitsByQuery(purchaseUnitSearch),
    [units, purchaseUnitSearch]
  );
  const filteredStockUnits = useMemo(
    () => filterUnitsByQuery(stockUnitSearch),
    [units, stockUnitSearch]
  );

  const openQuickCreate = (type) => {
    // This action originates in a Select menu. Keep the parent item dialog
    // mounted while that menu closes and the quick-create dialog opens.
    setOpen(true);
    if (type === "category") keepItemDialogOpenRef.current = true;
    setQuickCreateType(type);
    setQuickCategoryName("");
    setQuickUnitName("");
    setQuickUnitAbbreviation("");
  };

  const closeQuickCreate = () => {
    if (!isQuickCreating) {
      keepItemDialogOpenRef.current = false;
      setQuickCreateType(null);
    }
  };

  const handleQuickCreate = async () => {
    if (quickCreateType === "category") {
      const categoryName = quickCategoryName.trim();
      if (!categoryName) {
        openSnackbar("Enter a category name");
        return;
      }
      setIsQuickCreating(true);
      try {
        setPendingCategoryName(categoryName);
        const createdResult = await dispatch(
          createCategory({ categoryName, isActive: true, isDeleted: false })
        );
        const category = createdResult?.category || createdResult?.data || createdResult;
        if (category?._id) {
          setItemData((current) => ({
            ...current,
            category: { categoryName: category.categoryName, categoryId: category._id },
          }));
          setPendingCategoryName("");
          openSnackbar(`Category "${category.categoryName}" created`);
        } else {
          // ADD_NEW_CATEGORY has already populated the store; the effect
          // below resolves it by name without triggering a page-wide reload.
          openSnackbar(`Category "${categoryName}" created`);
        }
        setOpen(true);
        setQuickCreateType(null);
        // Material-UI can emit the parent dialog's close event while a nested
        // dialog is being removed. Re-assert the parent state on the next tick.
        if (quickCreateType === "category") {
          setTimeout(() => {
            setOpen(true);
            keepItemDialogOpenRef.current = false;
          }, 0);
        }
      } catch (error) {
        openSnackbar(error.message || "Unable to create category");
      } finally {
        setIsQuickCreating(false);
      }
      return;
    }

    const name = quickUnitName.trim();
    const abbreviation = quickUnitAbbreviation.trim();
    if (!name || !abbreviation) {
      openSnackbar("Enter a unit name and abbreviation");
      return;
    }
    setIsQuickCreating(true);
    try {
      const unit = await dispatch(createUnit({ name, abbreviation }, openSnackbar));
      if (!unit?._id) throw new Error("Unable to create unit");
      setItemData((current) => {
        // The dialog can be reopened while a quick-create request finishes;
        // rebuild the missing unit shape instead of reading units.sale/etc.
        const currentUnits = current.units || {};
        const selectedUnit = currentUnits[quickCreateType] || {};
        return {
          ...current,
          units: {
            ...currentUnits,
            [quickCreateType]: {
              ...selectedUnit,
              unit: unit._id,
            },
          },
        };
      });
      setQuickCreateType(null);
    } catch (error) {
      // createUnit displays the server error; retain values for correction.
    } finally {
      setIsQuickCreating(false);
    }
  };

  // Some API deployments return the category object wrapped differently. When
  // the store refreshes, resolve by name as a fallback and select it directly.
  useEffect(() => {
    if (!pendingCategoryName) return;
    const createdCategory = categories.find(
      (category) =>
        category.categoryName?.toLowerCase() === pendingCategoryName.toLowerCase()
    );
    if (!createdCategory?._id) return;
    setItemData((current) => ({
      ...current,
      category: {
        categoryName: createdCategory.categoryName,
        categoryId: createdCategory._id,
      },
    }));
    setPendingCategoryName("");
  }, [categories, pendingCategoryName]);

  const handleIsStaffRequiredChange = (event) => {
    // setTrackStock(event.target.checked);
    setItemData({
      ...itemData,
      isStaffReq: event.target.checked,
    });
  };
  useEffect(() => {
    if (!units.length) {
      dispatch(getAllUnits());
    }

    // dispatch(getItemsByUser({ search: user.result?._id || user.result.googleId }));
  }, [dispatch]);
  useEffect(() => {
    // See FloatingFooter.js - `categories` must not be a dependency, or an
    // empty catalog turns this into an infinite refetch loop (every fetch
    // returns a new-but-still-empty array reference).
    if (!categories.length) {
      dispatch(getAllCategories());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // useEffect(() => {
  //   if (itemId) {
  //     setOption("manualAdd");
  //   }
  //   // else {
  //   //   setOption("fileUpload");
  //   // }
  // }, [itemId]);

  // const handleSubmitItem = (e) => {
  //   e.preventDefault();
  //   if (validateForm()) {
  //     if (itemId) {
  //       dispatch(updateItem(itemId, itemData, openSnackbar));
  //       window.location.reload();
  //     } else {
  //       const updatedItemData = { ...itemData };
  //       // console.log(updatedItemData)

  //       updatedItemData.vat = profile?.userProfile?.commonVatRate;
  //       updatedItemData.stockQty.initialQty =
  //         updatedItemData.units?.stock?.quantity;
  //       updatedItemData.stockQty.currentQty =
  //         updatedItemData.units?.stock?.quantity;
  //       setItemData(updatedItemData);
  //       dispatch(createItem(updatedItemData, openSnackbar));
  //       console.log(updatedItemData)

  //       window.location.reload();
  //     }
  //     clear();
  //     handleClose();
  //   }
  // };

  

  const handleSubmitItem = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        if (itemId) {
          const payload = { ...itemData };
          // Stock quantity is display-only on edit. Keep the stored opening /
          // current qty so saving the form cannot overwrite the ledger.
          if (item?.toggleStock) {
            payload.units = {
              ...payload.units,
              stock: {
                ...payload.units?.stock,
                quantity: item.units?.stock?.quantity,
              },
            };
            payload.stockQty = {
              ...payload.stockQty,
              initialQty: item.stockQty?.initialQty,
              currentQty: item.stockQty?.currentQty,
            };
          }
          await dispatch(updateItem(itemId, payload, openSnackbar));
        } else {
          const updatedItemData = { ...itemData };
          updatedItemData.vat = effectiveProfile?.commonVatRate || 0;

          // Only set stock-related fields if track stock is enabled
          if (updatedItemData.toggleStock) {
            updatedItemData.stockQty.initialQty = parseFloat(
              updatedItemData.units?.stock?.quantity || 0
            );
            updatedItemData.stockQty.currentQty = parseFloat(
              updatedItemData.units?.stock?.quantity || 0
            );
            updatedItemData.units.stock.quantity = parseFloat(
              updatedItemData.units?.stock?.quantity || 0
            );
          } else {
            // When track stock is disabled, set stock fields to default values
            updatedItemData.stockQty = {
              initialQty: 0,
              currentQty: 0,
              minQty: updatedItemData.stockQty?.minQty || 0,
              maxQty: updatedItemData.stockQty?.maxQty || 0,
            };
            updatedItemData.units.stock = {
              unit: null,
              quantity: 0,
            };
          }

          console.log("Dispatching createItem with:", updatedItemData);
          const createdItem = await dispatch(createItem(updatedItemData, openSnackbar));
          onCreated?.(createdItem);
        }
        clear();
        handleClose();
      } catch (error) {
        console.error("Failed to save item:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (!name || (typeof value === "string" && value.startsWith("__create_"))) return;

    setItemData((prevItemData) => {
      const keys = name.split(".");
      const updatedData = { ...prevItemData };
      let currentLevel = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!currentLevel[key]) {
          currentLevel[key] = {};
        }
        currentLevel = currentLevel[key];
      }

      // Handle dropdowns explicitly
      if (name.includes("unit")) {
        currentLevel[keys[keys.length - 1]] = value; // Assign the _id directly
      } else {
        currentLevel[keys[keys.length - 1]] = value;
      }

      return updatedData;
    });
  };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;

  //   if (!name) return; // Ensure the input has a name

  //   setItemData((prevItemData) => {
  //     // Split the name into keys for nested updates
  //     const keys = name.split(".");

  //     // Create a deep copy of the existing data
  //     const updatedData = { ...prevItemData };

  //     // Recursively traverse and set the value at the appropriate depth
  //     let currentLevel = updatedData;
  //     for (let i = 0; i < keys.length - 1; i++) {
  //       const key = keys[i];

  //       // Ensure the object exists at each level
  //       if (!currentLevel[key]) {
  //         currentLevel[key] = {};
  //       }
  //       currentLevel = currentLevel[key];
  //     }

  //     // Set the value at the last level
  //     currentLevel[keys[keys.length - 1]] = value;

  //     return updatedData;
  //   });
  // };

  // function handleFileChange(event) {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onload = (e) => {
  //       const base64ImageData = e.target.result;
  //       setItemData({ ...itemData, img: base64ImageData });
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // }

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const url = "https://api.cloudinary.com/v1_1/almpo/image/upload"; // Replace 'almpo' with your Cloudinary cloud name
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "invoice"); // Replace with your upload preset

    try {
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Upload failed");
      }

      const data = await response.json();
      setItemData({ ...itemData, img: data.secure_url }); // Store Cloudinary URL
    } catch (error) {
      console.error("Error uploading to Cloudinary:", error);
    }
  };

  // const handleOptionChange = (selectedOption) => {
  //   setOption(selectedOption);
  //   // if (selectedOption === "fileUpload" && !itemId) {
  //   //   history.push("/bulk-upload"); // Redirect to bulk upload page
  //   //   handleClose(); // Close the dialog
  //   // }
  // };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    // debugger;
    if (itemData.itemName.trim() === "") {
      newErrors.itemName = "Item name is required";
      isValid = false;
    }
    if (!itemData.units?.sale?.price) {
      newErrors.salesPrice = "Sales price is required";
      isValid = false;
    }
    // Optional - only validated when actually filled in (blank means no
    // minimum, which is a perfectly valid choice for most items).
    const minQtyRaw = itemData.units?.sale?.minQty;
    if (minQtyRaw !== "" && minQtyRaw != null) {
      const minQtyNum = Number(minQtyRaw);
      if (Number.isNaN(minQtyNum) || minQtyNum <= 0) {
        newErrors.minQty = "Minimum sale quantity must be a positive number";
        isValid = false;
      }
    }

    // if (!itemData.units?.purchase?.cost) {
    //   newErrors.costPrice = "Purchase cost is required";
    //   isValid = false;
    // }

    // if (itemData.units?.sale?.unit?._id.trim() === "") {
    //   newErrors.saleUnit = "Sales unit is required";
    //   isValid = false;
    // }
    // if (itemData.units?.stock?.unit?._id.trim() === "") {
    //   newErrors.saleUnit = "Stock unit is required";
    //   isValid = false;
    // }
    // if (!itemData.units?.stock?.quantity) {
    //   newErrors.stockUnit = "Stock unit is required";
    //   isValid = false;
    // }

    setErrors(newErrors);
    return isValid;
  };

  const clear = () => {
    setItemData({
      itemName: "",
      category: "",
      categoryId: "",
      unitPrice: "",
      unit: "",
      itemId: [],
      img: null,
      stockQty: null,
      vat: "",
    });
    setErrors({});
    setTrackStock(false);
  };

  useEffect(() => {
    if (item) {
      setItemData({
        ...item,
        units: {
          sale: {
            unit: item.units?.sale?.unit?._id || null, // Store only the ID
            price: item.units?.sale?.price || "",
            minQty: item.units?.sale?.minQty || "",
          },
          purchase: {
            unit: item.units?.purchase?.unit?._id || null, // Store only the ID
            cost: item.units?.purchase?.cost || "",
          },
          stock: {
            unit: item.units?.stock?.unit?._id || null, // Store only the ID
            quantity: item.units?.stock?.quantity || 0,
          },
        },
        category: {
          categoryName: item.category?.categoryName || "",
          categoryId: item.category?.categoryId || null,
        },
      });
      setIsEditMode(true);
      if (item.toggleStock && item._id && getCurrentStockQty) {
        getCurrentStockQty(item._id).then(({ currentStock }) => {
          const liveQty = parseFloat(currentStock);
          if (!Number.isFinite(liveQty)) return;
          setItemData((prev) => ({
            ...prev,
            units: {
              ...prev.units,
              stock: {
                ...prev.units.stock,
                quantity: liveQty,
              },
            },
          }));
        });
      }
    } else {
      // When opening for a new item, reset the form and switch to add mode
      clear();
      setIsEditMode(false);
      // Pre-fill from the search text of whatever "create new item" dropdown
      // triggered this (Purchase/Stock Adjustment quick-create) - only
      // meaningful while opening fresh, so gated on `open` too.
      if (open && initialItemName) {
        setItemData((current) => ({ ...current, itemName: initialItemName }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, open]);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("profile")));
  }, [location]);

  // useEffect(() => {
  //   var checkId = user?.result?._id;
  //   if (checkId !== undefined) {
  //     setItemData({ ...itemData, itemId: [checkId] });
  //   } else {
  //     setItemData({ ...itemData, itemId: [user?.result?.googleId] });
  //   }
  // }, [location]);

  const handleClose = () => {
    setItemData({
      itemName: "",
      category: "",
      categoryId: "",
      unitPrice: "",
      costPrice: "",
      unit: "",
      itemId: [],
      img: null,
      vat: "",
    });
    setErrors({});
    setOpen(false);
  };
  // const handleOptionChange = (selectedOption) => {
  //   setOption(selectedOption);
  // };
  return (
    <div>
      <Dialog
        onClose={(event, reason) => {
          if (keepItemDialogOpenRef.current) return;
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        fullScreen={isMobile}
        maxWidth="md"
        PaperProps={{
          style: {
            maxHeight: isMobile ? "100vh" : "88vh",
          },
        }}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          style={{
            paddingLeft: "20px",
            color: "white",
            backgroundColor: "#ef7f1a",
          }}
        >
          {itemId ? "Edit Item" : "New Item"}
        </DialogTitle>
        <DialogContent dividers>
          {/* {!itemId && (
            <FormGroup row >
              <FormControlLabel
                className={classes.radioLabel}
                control={
                  <Radio
                    checked={option === "manualAdd"}
                    onChange={() => handleOptionChange("manualAdd")}
                    value="manualAdd"
                    color="primary"
                  />
                }
                label="Manually Add Item"
              />

              <FormControlLabel
                control={
                  <Radio
                    checked={option === "fileUpload"}
                    onChange={() => handleOptionChange("fileUpload")}
                    value="fileUpload"
                    color="primary"
                  />
                }
                label="Bulk Upload via File"
              />
            </FormGroup>
          )} */}
          {/* {option === "fileUpload" && (
            <FileUpload setOpen={setOpen} open={open}  />
          )} */}
          {/* {option === "fileUpload" && (
            <Link to="/bulk-upload" style={{ marginLeft: 16 }}>
              <Button variant="outlined" color="primary"  onClick={() => (window.location.href = "/bulk-upload")}>
                Bulk Upload Items
              </Button>
            </Link>
          )} */}

          <div>
            <Container className={classes.container}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Name"
                    variant="outlined"
                    className={classes.inputStyle}
                    name="itemName"
                    type="text"
                    required
                    onChange={handleChange}
                    value={itemData.itemName}
                    error={!!errors.itemName} // Check if error exists
                    helperText={errors.itemName} // Display error message
                  />
                </Grid>
                {/* <Grid item xs={12} sm={6}>
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="demo-simple-select-outlined-label">
                        Category
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={
                          itemData.category ? itemData.category.categoryId : ""
                        }
                        onChange={(e) => {
                          const selectedCategoryId = e.target.value;
                          const selectedCategory = categories.find(
                            (category) => category._id === selectedCategoryId
                          );

                          setItemData({
                            ...itemData,
                            category: {
                              categoryName: selectedCategory
                                ? selectedCategory?.categoryName
                                : "",
                              categoryId: selectedCategoryId,
                            },
                          });
                        }}
                        label="Category"
                      >
                        {categories.map((category, index) => (
                          <MenuItem key={index} value={category._id}>
                            {category.categoryName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid> */}
                <Grid item xs={12} sm={6}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                      labelId="category-label"
                      id="category-select"
                      value={itemData?.category?.categoryId || ""}
                      onChange={(e) => {
                        const selectedCategoryId = e.target.value;
                        if (
                          typeof selectedCategoryId === "string" &&
                          selectedCategoryId.startsWith("__create_")
                        ) {
                          return;
                        }
                        const selectedCategory = categories.find(
                          (category) => category._id === selectedCategoryId
                        );
                        setItemData({
                          ...itemData,
                          category: {
                            categoryName: selectedCategory?.categoryName || "",
                            categoryId: selectedCategoryId,
                          },
                        });
                      }}
                      label="Category"
                      MenuProps={menuProps}
                      onOpen={() => setCategorySearch("")}
                    >
                      <SearchListHeader
                        classes={classes}
                        value={categorySearch}
                        onChange={(event) => setCategorySearch(event.target.value)}
                        placeholder="Search categories..."
                      />
                      {filteredCategories.length === 0 && (
                        <MenuItem disabled className={classes.noResultsItem}>
                          No categories found
                        </MenuItem>
                      )}
                      {filteredCategories.map((category) => (
                        <MenuItem
                          key={category._id}
                          value={category._id}
                          disabled={!category.isActive} // Disable if inactive
                          className={
                            !category.isActive ? classes.disabledMenuItem : ""
                          }
                        >
                          {category.isActive
                            ? category.categoryName
                            : `${category.categoryName} (INACTIVE)`}
                        </MenuItem>
                      ))}
                      <MenuItem
                        className={classes.quickCreateItem}
                        value="__create_category__"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          openQuickCreate("category");
                        }}
                      >
                        <AddIcon fontSize="small" style={{ marginRight: 8 }} />
                        Create new category
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                    <TextField
                      label="Sales Rate"
                      variant="outlined"
                      className={classes.inputStyle}
                      name="unitPrice"
                      type="text"
                      required
                      onChange={handleChange}
                      value={itemData.unitPrice}
                      error={!!errors.unitPrice} // Check if error exists
                      helperText={errors.unitPrice} // Display error message
                    />
                  </Grid> */}
                {/* <Grid item xs={12} sm={6}>
                    <TextField
                      label="Purchase Rate"
                      variant="outlined"
                      className={classes.inputStyle}
                      name="costPrice"
                      type="number"
                      onChange={handleChange}
                      value={itemData.costPrice}
                      error={!!errors.costPrice} // Check if error exists
                      helperText={errors.costPrice} // Display error message
                    />
                  </Grid> */}

                <Grid item xs={12} sm={6}>
                  <FormControl
                    fullWidth
                    variant="outlined"
                    error={!!errors.saleUnit}
                  >
                    <InputLabel id="sales-unit-label">Sales Unit</InputLabel>
                    <Select
                      labelId="sales-unit-label" // Link the InputLabel to the Select
                      id="sales-unit-select" // Optional but recommended for accessibility
                      name="units.sale.unit"
                      value={itemData?.units?.sale?.unit || ""}
                      onChange={handleChange}
                      label="Sales Unit" // Ensure the label prop matches the InputLabel text
                      MenuProps={menuProps}
                      onOpen={() => setSaleUnitSearch("")}
                    >
                      <SearchListHeader
                        classes={classes}
                        value={saleUnitSearch}
                        onChange={(event) => setSaleUnitSearch(event.target.value)}
                        placeholder="Search sales unit..."
                      />
                      {filteredSaleUnits.length === 0 && (
                        <MenuItem disabled className={classes.noResultsItem}>
                          No units found
                        </MenuItem>
                      )}
                      {filteredSaleUnits.map((unit) => (
                        <MenuItem key={unit._id} value={unit._id}>
                          {unit.name} ({unit.abbreviation})
                        </MenuItem>
                      ))}
                      <MenuItem
                        className={classes.quickCreateItem}
                        value="__create_sale_unit__"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          openQuickCreate("sale");
                        }}
                      >
                        <AddIcon fontSize="small" style={{ marginRight: 8 }} />
                        Create new unit
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Sales Price"
                    name="units.sale.price"
                    variant="outlined"
                    className={classes.inputStyle}
                    type="number"
                    value={itemData?.units?.sale?.price}
                    onChange={handleChange}
                    error={!!errors.salesPrice}
                    helperText={errors.salesPrice}
                    inputProps={{ step: "0.001", min: "0" }}
                  />
                  <FormHelperText style={{ marginTop: 4 }}>
                    Price per {selectedSaleUnit?.abbreviation || "sale unit"}
                  </FormHelperText>
                </Grid>

                {minSaleQuantityFeatureOn && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      label={`Minimum Sale Quantity${selectedSaleUnit?.abbreviation ? ` (${selectedSaleUnit.abbreviation})` : ""}`}
                      name="units.sale.minQty"
                      variant="outlined"
                      className={classes.inputStyle}
                      type="number"
                      value={itemData?.units?.sale?.minQty}
                      onChange={handleChange}
                      error={!!errors.minQty}
                      helperText={errors.minQty}
                      inputProps={{ step: "0.001", min: "0" }}
                    />
                    {!errors.minQty && (
                      <FormHelperText style={{ marginTop: 4 }}>
                        Optional - leave blank for no minimum.
                      </FormHelperText>
                    )}
                  </Grid>
                )}

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="purchase-unit-label">
                      Purchase Unit
                    </InputLabel>
                    <Select
                      labelId="purchase-unit-label" // Link the InputLabel to the Select
                      id="purchase-unit-select" // Optional but recommended for accessibility
                      name="units.purchase.unit"
                      MenuProps={menuProps}
                      value={itemData?.units?.purchase?.unit || ""}
                      onChange={handleChange}
                      label="Purchase Unit" // Ensure the label prop matches the InputLabel text
                      onOpen={() => setPurchaseUnitSearch("")}
                    >
                      <SearchListHeader
                        classes={classes}
                        value={purchaseUnitSearch}
                        onChange={(event) => setPurchaseUnitSearch(event.target.value)}
                        placeholder="Search purchase unit..."
                      />
                      {filteredPurchaseUnits.length === 0 && (
                        <MenuItem disabled className={classes.noResultsItem}>
                          No units found
                        </MenuItem>
                      )}
                      {filteredPurchaseUnits.map((unit) => (
                        <MenuItem key={unit._id} value={unit._id}>
                          {unit.name} ({unit.abbreviation})
                        </MenuItem>
                      ))}
                      <MenuItem
                        className={classes.quickCreateItem}
                        value="__create_purchase_unit__"
                        onMouseDown={(event) => event.preventDefault()}
                        onClick={(event) => {
                          event.preventDefault();
                          event.stopPropagation();
                          openQuickCreate("purchase");
                        }}
                      >
                        <AddIcon fontSize="small" style={{ marginRight: 8 }} />
                        Create new unit
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Opening Purchase Cost"
                    name="units.purchase.cost"
                    type="number"
                    variant="outlined"
                    className={classes.inputStyle}
                    value={itemData?.units?.purchase?.cost}
                    onChange={handleChange}
                    error={!!errors.costPrice}
                    helperText={errors.costPrice}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Barcode"
                    variant="outlined"
                    className={classes.inputStyle}
                    name="barcode"
                    type="number"
                    onChange={handleChange}
                    value={itemData.barcode}
                    error={!!errors.barcode} // Check if error exists
                    helperText={errors.barcode} // Display error message
                  />
                </Grid>

                {effectiveProfile?.vatOptions === "itemBased" &&
                  (!effectiveProfile || effectiveProfile.vatType !== "common") && (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label={taxLabel}
                        variant="outlined"
                        className={classes.inputStyle}
                        name="vat"
                        type="number"
                        onChange={handleChange}
                        value={itemData.vat}
                        error={!!errors.vat} // Check if error exists
                        helperText={errors.vat} // Display error message
                      />
                    </Grid>
                  )}

                <Grid item xs={12} sm={6}>
                  {!itemData.img ? (
                    <>
                      <input
                        accept="image/*"
                        className={classes.input}
                        onChange={handleFileChange}
                        id="icon-button-file"
                        type="file"
                      />
                      <label htmlFor="icon-button-file" style={{ display: "block" }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          startIcon={<PhotoCamera />}
                          fullWidth
                          style={{ height: 56, textTransform: "none" }}
                        >
                          Upload Image
                        </Button>
                      </label>
                    </>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                        height: 56,
                      }}
                    >
                      <img
                        src={itemData.img}
                        alt="Item"
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 8,
                          objectFit: "cover",
                        }}
                      />
                      <Typography variant="body2" style={{ flex: 1 }}>
                        Image selected
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() =>
                          setItemData((prevData) => ({
                            ...prevData,
                            img: null,
                          }))
                        }
                      >
                        <CloseIcon />
                      </IconButton>
                    </div>
                  )}
                </Grid>

                {/* <Grid item xs={12} sm={6}>
                    <FormControlLabel
                      label="Is Staff Required?"
                      control={
                        <Switch
                          checked={itemData?.isStaffReq}
                          onChange={handleIsStaffRequiredChange}
                          name="isStaffReq"
                          color="primary"
                        />
                      }
                    />
                  </Grid> */}
              </Grid>
            </Container>
            {itemData.category.categoryName != "Services" && (
              <Container
                className={classes.container}
                style={{ marginTop: "5px" }}
              >
                <FormControlLabel
                  label="Track Stock"
                  control={
                    <Switch
                      checked={
                        itemData?.toggleStock
                          ? itemData.toggleStock
                          : trackStock
                      }
                      onChange={handleTrackStockChange}
                      name="trackStock"
                      color="primary"
                    />
                  }
                />
                {itemData.toggleStock && (
                  <>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined">
                          <InputLabel id="stock-unit-label">
                            Stock Unit
                          </InputLabel>
                          <Select
                            labelId="stock-unit-label" // Link the InputLabel to the Select
                            id="stock-unit-select" // Optional but recommended for accessibility
                            name="units.stock.unit"
                            value={itemData?.units?.stock?.unit || ""}
                            onChange={handleChange}
                            MenuProps={menuProps}
                            label="Stock Unit" // Ensure the label prop matches the InputLabel text
                            onOpen={() => setStockUnitSearch("")}
                          >
                            <SearchListHeader
                              classes={classes}
                              value={stockUnitSearch}
                              onChange={(event) => setStockUnitSearch(event.target.value)}
                              placeholder="Search stock unit..."
                            />
                            {filteredStockUnits.length === 0 && (
                              <MenuItem disabled className={classes.noResultsItem}>
                                No units found
                              </MenuItem>
                            )}
                            {filteredStockUnits.map((unit) => (
                              <MenuItem key={unit._id} value={unit._id}>
                                {unit.name} ({unit.abbreviation})
                              </MenuItem>
                            ))}
                            <MenuItem
                              className={classes.quickCreateItem}
                              value="__create_stock_unit__"
                              onMouseDown={(event) => event.preventDefault()}
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                openQuickCreate("stock");
                              }}
                            >
                              <AddIcon fontSize="small" style={{ marginRight: 8 }} />
                              Create new unit
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Stock Quantity"
                          name="units.stock.quantity"
                          type="number"
                          variant="outlined"
                          className={classes.inputStyle}
                          value={itemData?.units?.stock?.quantity}
                          onChange={handleChange}
                          disabled={Boolean(itemId && item?.toggleStock)}
                          inputProps={{ step: "0.001", min: "0" }}
                          error={!!errors.stockUnit}
                          helperText={errors.stockUnit}
                        />
                        <FormHelperText style={{ marginTop: 4 }}>
                          {itemId && item?.toggleStock
                            ? "Current stock — change it with a purchase, sale, or stock adjustment"
                            : `Enter stock in ${selectedStockUnit?.abbreviation || "stock unit"}`}
                        </FormHelperText>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Max Qty"
                          variant="outlined"
                          className={classes.inputStyle}
                          name="stockQty.maxQty"
                          type="number"
                          onChange={handleChange}
                          value={itemData?.stockQty?.maxQty}
                          error={!!errors?.stockQty?.maxQty} // Check if error exists
                          helperText={errors?.stockQty?.maxQty}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Min Qty"
                          variant="outlined"
                          className={classes.inputStyle}
                          name="stockQty.minQty"
                          type="number"
                          onChange={handleChange}
                          value={itemData?.stockQty?.minQty}
                          error={!!errors?.stockQty?.minQty} // Check if error exists
                          helperText={errors?.stockQty?.minQty}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Container>
            )}
            <Container style={{ margin: "10px" }}>
              <Button
                autoFocus
                onClick={handleSubmitItem}
                variant="contained"
                disabled={!units.length || !categories.length || isSubmitting}
                startIcon={
                  isSubmitting ? (
                    <CircularProgress size={16} color="inherit" />
                  ) : null
                }
                style={{
                  backgroundColor: "#ef7f1a",
                  color: "white",
                }}
              >
                {isSubmitting ? "Saving..." : "Save Item"}
              </Button>
            </Container>
          </div>
        </DialogContent>
      </Dialog>
      <Dialog
        open={Boolean(quickCreateType)}
        onClose={closeQuickCreate}
        aria-labelledby="quick-create-title"
        maxWidth="xs"
        fullWidth
      >
        <MuiDialogTitle id="quick-create-title">
          {quickCreateType === "category" ? "Create Category" : "Create Unit"}
        </MuiDialogTitle>
        <MuiDialogContent className={classes.quickDialogContent}>
          {quickCreateType === "category" ? (
            <TextField
              autoFocus
              label="Category name"
              value={quickCategoryName}
              onChange={(event) => setQuickCategoryName(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") handleQuickCreate();
              }}
              variant="outlined"
              fullWidth
            />
          ) : (
            <>
              <TextField
                autoFocus
                label="Unit name"
                value={quickUnitName}
                onChange={(event) => setQuickUnitName(event.target.value)}
                variant="outlined"
                fullWidth
              />
              <TextField
                label="Abbreviation"
                value={quickUnitAbbreviation}
                onChange={(event) => setQuickUnitAbbreviation(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") handleQuickCreate();
                }}
                variant="outlined"
                fullWidth
                helperText="Example: Kilogram → kg"
              />
            </>
          )}
        </MuiDialogContent>
        <MuiDialogActions>
          <Button onClick={closeQuickCreate} disabled={isQuickCreating}>
            Cancel
          </Button>
          <Button
            onClick={handleQuickCreate}
            color="primary"
            variant="contained"
            disabled={isQuickCreating}
            startIcon={isQuickCreating ? <CircularProgress size={16} color="inherit" /> : <AddIcon />}
          >
            Create & Select
          </Button>
        </MuiDialogActions>
      </Dialog>
    </div>
  );
};

export default AddItem;
